import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal} from 'antd'

@inject('store') @observer
class DebugModal extends Component {
  handleOk = () => {
    const {paperTrading} = this.props.store
    paperTrading.debug.run()
    this.props.close()
  }
  render() {
    return(
      <Modal
        title='This action will remove all current data for selected session'
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.close}
      />
    )
  }
}

export default DebugModal
